<template>
  <section class="wc-cart-drawer-root">
    <FocusLoop
      ><transition name="wc-cart-drawer">
        <WCCartDrawer
          v-click-outside="close"
          v-if="show"
          :line-items="getCartItems"
          :carts="nonEmptyCarts"
          @keydown.esc="close"
        />
      </transition>
    </FocusLoop>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { FocusLoop } from '@vue-a11y/focus-loop';
import vClickOutside from 'click-outside-vue3';
import emitter from '@/eventBus';
import CartItemControls from '@/modules/cart/mixins/CartControls/CartItemControls';
import WCCartDrawer from '../WCCartDrawer/WCCartDrawer.vue';

export default {
  components: { WCCartDrawer, FocusLoop },
  mixins: [CartItemControls],
  name: 'WCCartDrawerRoot',
  data() {
    return {
      show: false,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  created() {
    emitter.$on('cartDrawer:open', () => {
      this.open();
    });

    emitter.$on('cartDrawer:close', () => {
      this.close();
    });

    emitter.$on('cartDrawer:toggle', () => {
      this.toggle();
    });
  },
  computed: {
    ...mapGetters({
      nonEmptyCarts: 'cart/nonEmptyCarts',
    }),
    getCartItems() {
      return this.cartLineItems.filter(item => item.type === 1 || item.type === 60);
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    toggle() {
      this.show = !this.show;
    },
  },
  watch: {
    $route(to, from) {
      if (this.show && to !== from) {
        this.close();
      }
    },
    /**
     * Focus the header shopping cart button on close
     */
    show() {
      if (!this.show) {
        document.getElementById('headerCartButton')?.focus();
      }
    },
  },
};
</script>

<style scoped>
.wc-cart-drawer-enter-active,
.wc-cart-drawer-leave-active {
  transition: all 0.3s ease-in-out;
}

.wc-cart-drawer-enter,
.wc-cart-drawer-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
